import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import {
  fetchMouleSelection,
  fetchMouleSelectionFaqQandA,
  fetchMouleSelectionMyairports,
} from "../AirlineImages/FetchModule";
import { fetchKeyInfoListOptions } from "./FetchKeyInfoListOptions";

export const getCentralizedFAQsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  centralizedQandAs: [
    {
      fieldName: "Sequence No.",
      fieldValue: "order_sequence",
      className: "col-span-6",
      type: "text",
      name: "order_sequence",
      formType: "number",
      label: "Sequence No.",
      placeholder: "Enter Sequence No.",
      validation: { required: "Sequence No. is required" },
    },
    {
      fieldName: "Question (EN)",
      fieldValue: "title_en",
      className: "col-span-6",
      type: "text",
      name: "title_en",
      formType: "input",
      label: "Question (EN)",
      placeholder: "Enter Question (EN)",
      validation: { required: "Question (EN) is required" },
    },
    {
      fieldName: "Question (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Question (MS)",
      placeholder: "Enter Question (MS)",
      // validation: { required: "Question (MS) is required" },
    },
    {
      fieldName: "Question (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Question (ZH)",
      placeholder: "Enter Question (ZH)",
      // validation: { required: "Question (ZH) is required" },
    },
    {
      fieldName: "Content (EN)",
      fieldValue: "answer_en",
      className: "col-span-6",
      type: "text",
      name: "answer_en",
      formType: "richText",
      label: "Content (EN)",
      placeholder: "Enter Content (EN)",
      validation: { required: "Content (EN) is required" },
    },
    {
      fieldName: "Content (MS)",
      fieldValue: "answer_malay",
      className: "col-span-6",
      type: "text",
      name: "answer_malay",
      formType: "richText",
      label: "Content (MS)",
      placeholder: "Enter Content (MS)",
      // validation: { required: "Content (MS) is required" },
    },
    {
      fieldName: "Content (ZH)",
      fieldValue: "answer_mandarian",
      className: "col-span-6",
      type: "text",
      name: "answer_mandarian",
      formType: "richText",
      label: "Content (ZH)",
      placeholder: "Enter Content (ZH)",
      // validation: { required: "Content (ZH) is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "module_name",
      className: "col-span-6",
      type: "select",
      name: "module_name",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionFaqQandA,
    },
    {
      fieldName: "Category",
      fieldValue: "key_info_type",
      className: "col-span-6",
      type: "select",
      name: "key_info_type",
      formType: "select",
      label: "Category",
      placeholder: "Select Category",
      // validation: { required: "Category is required" },
      loadOptions: fetchKeyInfoListOptions,
      note: "Category is only for the My Airports",
    },

    // {
    //     fieldName: "MAGP Published",
    //     fieldValue: "magp_sync",
    //     className: "col-span-12",
    //     type: "checkbox",
    //     name: "magp_sync",
    //     formType: "checkbox",
    //     label: "MAGP Published",
    //     placeholder: "Enter MAGP Published",
    //     // validation: { required: "MAGP Publish is required" },
    // },
    // {
    //     fieldName: "ERAMAN Published",
    //     fieldValue: "eraman_sync",
    //     className: "col-span-12",
    //     type: "checkbox",
    //     name: "eraman_sync",
    //     formType: "checkbox",
    //     label: "ERAMAN Published",
    //     placeholder: "Enter ERAMAN Published",
    //     // validation: { required: "ERAMAN Publish is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },a
    },
  ],
  centralizedFaqsCategories: [
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "module_name",
      className: "col-span-6",
      type: "select",
      name: "module_name",
      formType: "multiSelect",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelectionMyairports,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },a
    },
  ],
  centralizedKeyInfoBanner: [
    {
      fieldName: "Title (EN)",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "title_malay",
      className: "col-span-6",
      type: "text",
      name: "title_malay",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "title_mandarin",
      className: "col-span-6",
      type: "text",
      name: "title_mandarin",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Modules / Airports",
      fieldValue: "module_name",
      className: "col-span-6",
      type: "select",
      name: "module_name",
      formType: "select",
      label: "Modules / Airports",
      placeholder: "Enter Modules / Airports",
      validation: { required: "Modules / Airports is required" },
      loadOptions: fetchMouleSelection,
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
};
